import React, { FC } from 'react'
import SALink from 'components/SALink'
import SeoContentConnector, { ConnectorProps as SeoContentProps } from '../../connectors/SeoContent'
import styles from './SEOContent.module.scss'
import { mergeTiles } from './helpers'

const NarrowYourResults: FC<SeoContentProps> = ({ metadata }) => {
  const { tileRow } = metadata || {}

  if (!metadata || !metadata.tileRow || !metadata.tileRow.length) {
    return null
  }
  const mergedTiles = mergeTiles(tileRow)

  return (
    <div className={styles.narrowYourResultsContainer}>
      <h4>Narrow Your Results</h4>
      {mergedTiles.map((row) => (
        <div key={row.title} className={styles.tileContainer}>
          <h6>{row.title}</h6>
          <div className={styles.keywordContainer}>
            {row.tiles.map((tile, key) => (
              <div className={styles.chipBox} key={key}>
                <SALink href={tile.url}>
                  <p className='defaultTypographySmall'>{tile.name}</p>
                </SALink>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default SeoContentConnector(NarrowYourResults)
